import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as addonsActions from "../../actions/addonsActions";
import * as generalActions from "../../actions/generalActions";
import { Cart } from "../../components/Cart";
// import {
//   Cart as MobileCart,
//   CartExpander as MobileCartExpander
// } from "../../components/MobileCart";

import {
  isRTL,
  getGlobalCurrency,
  getGlobalCurrencyCode,
  getCartTotalPrices,
  getSelectedHotelName,
  getSelectedDataForPax
  // getSumOfSelectedRates
} from "../../reducers";
import PriceDisplay from "../PriceDisplay";

class CartContainer extends Component {
  convertedRate = (price, currencyCode, currency) => {
    return (
      <PriceDisplay
        price={price}
        currentCurrencyCode={currencyCode}
        fallBackCurrencySymbol={currency}
      >
        {convertedPrice => convertedPrice}
      </PriceDisplay>
    );
  };

  onAddonDecrementClick = (paxId, addonCode) => {
    const { actions } = this.props;
    actions.onAddonRemove(paxId, addonCode);
  };

  render() {
    const {
      actions,
      paxList,
      // sumOfSelectedRates,
      selectedDataForPax,
      // addons,
      // selectedPaxId,
      titles,
      isRtl,
      promoCode,
      isPromoCodeValid,
      isMobileView,
      // cartTotalPrice,
      // simpleClubCartTotalPrice,
      //new cart
      cartTotalPrices,
      cartClubTotalPrices,
      clubUserLoggedIn,
      discountClubConfig,
      globalCurrency,
      globalCurrencyCode,
      selectedCurrency,
      checkinDate,
      checkoutDate,
      propertyName,
      propertyType,
      // onItemClick,
      // onSubmit,
      // onEditAddons,
      // getInitialHeight,
      // redirectFormRef,
      isShowCancellationPolicy,
      onShowCancellationPolicy,
      bookingRatesEnabled,
      bookingRates,
      placeHolders,
      displayPriceWithoutTaxes,
      taxesPrecentage
      // showCartSubmitBtn,
      // isDealMode
    } = this.props;

    // const canSubmit = sumOfSelectedRates == paxList.length;

    // const canEditAddons =
    //   addons[selectedPaxId] && addons[selectedPaxId].length > 0;

    //const canEditAddons = false;

    const items = paxList.map(p => {
      const selectedRoom =
        selectedDataForPax &&
        selectedDataForPax[p.id] &&
        selectedDataForPax[p.id].room;

      const selectedRate =
        selectedDataForPax &&
        selectedDataForPax[p.id] &&
        selectedDataForPax[p.id].rate;

      const roomName = selectedRoom && selectedRoom.name;
      const planName = selectedRate && selectedRate.planName;

      const selectedAddons =
        (selectedDataForPax && selectedDataForPax[p.id].selectedAddons) || [];

      const formattedAddons = selectedAddons.map(addon => {
        return {
          ...addon,
          ...(selectedRoom && {
            priceToShow: this.convertedRate(
              addon.price,
              selectedRoom.currencyCode,
              selectedRoom.currency
            )
          })
        };
      });

      return {
        id: p.id,
        pax: p,
        name: p.id + 1,
        roomId: selectedRoom && selectedRoom.id,
        rateId: selectedRate && selectedRate.id,
        roomName,
        planName,
        price: selectedRate && selectedRate.totalPrice,
        clubPrice: selectedRate && selectedRate.simpleClubTotalPrice,
        currency: selectedRoom && selectedRoom.currency,
        currencyCode: selectedRate && selectedRate.currencyCode,
        selectedAddons: formattedAddons,
        isPackage: !!(selectedRate && selectedRate.isPackage)
      };
    });

    const toRender = (
      <Cart
        isMobileView={isMobileView}
        propertyName={propertyName}
        propertyType={propertyType}
        promoCode={promoCode}
        isPromoCodeValid={isPromoCodeValid}
        items={items}
        onAddonRemove={this.onAddonDecrementClick}
        titles={titles}
        isRtl={isRtl}
        // new cart
        totalPrices={cartTotalPrices}
        clubTotalPrices={cartClubTotalPrices}
        clubUserLoggedIn={clubUserLoggedIn}
        discountClubConfig={discountClubConfig}
        selectedCurrency={selectedCurrency}
        globalCurrency={globalCurrency}
        globalCurrencyCode={globalCurrencyCode}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        bookingRatesEnabled={bookingRatesEnabled}
        bookingRates={bookingRates}
        showCancellationPolicy={isShowCancellationPolicy}
        onShowCancellationPolicy={onShowCancellationPolicy}
        onNewSearchClick={actions.openSearchboxWin}
        placeHolders={placeHolders}
        displayPriceWithoutTaxes={displayPriceWithoutTaxes}
        taxesPrecentage={taxesPrecentage}
      />
    );
    return toRender;
  }
}

CartContainer.propTypes = {
  isMobileView: PropTypes.bool,
  //showCartSubmitBtn: PropTypes.bool,
  //selectedPaxId: PropTypes.number,
  isRtl: PropTypes.bool,
  titles: PropTypes.object,
  paxList: PropTypes.array,
  // addons: PropTypes.object,
  promoCode: PropTypes.string,
  isPromoCodeValid: PropTypes.bool,
  //cartTotalPrice: PropTypes.number,
  selectedDataForPax: PropTypes.object,
  //simpleClubCartTotalPrice: PropTypes.number,
  bookingRates: PropTypes.object,

  // new cart
  cartTotalPrices: PropTypes.object,
  cartClubTotalPrices: PropTypes.object,

  clubUserLoggedIn: PropTypes.bool,
  discountClubConfig: PropTypes.object,
  globalCurrency: PropTypes.string,
  globalCurrencyCode: PropTypes.string,
  selectedCurrency: PropTypes.string,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  propertyName: PropTypes.string,
  propertyType: PropTypes.string,
  // sumOfSelectedRates: PropTypes.number,
  //onItemClick: PropTypes.func,
  // onSubmit: PropTypes.func,
  //onEditAddons: PropTypes.func,
  //getInitialHeight: PropTypes.func,
  //redirectFormRef: PropTypes.func,
  bookingRatesEnabled: PropTypes.bool,
  isShowCancellationPolicy: PropTypes.bool,
  onShowCancellationPolicy: PropTypes.func,
  //isDealMode: PropTypes.bool,
  actions: PropTypes.object,
  placeHolders: PropTypes.array,
  displayPriceWithoutTaxes: PropTypes.bool,
  taxesPrecentage: PropTypes.number
};

const mapStateToProps = store => {
  const {
    titles,
    addons,
    paxList,
    isMobileView,
    selectedPaxId,
    clubUserLoggedIn,
    discountClubConfig,
    selectedCurrency,
    promoCode,
    isPromoCodeValid,
    checkinDate,
    checkoutDate,
    ShowCancellationPolicy,
    showCartSubmitBtn,
    isDealMode,
    bookingRates,
    bookingRatesEnabled,
    propertyType,
    placeHolders,
    displayPriceWithoutTaxes,
    taxesPrecentage
  } = store;
  const isRtl = isRTL(store);

  //new cart
  const cartTotalPrices = getCartTotalPrices(store);
  const cartClubTotalPrices = getCartTotalPrices(store, true);

  const globalCurrency = getGlobalCurrency(store);
  const globalCurrencyCode = getGlobalCurrencyCode(store);
  const selectedDataForPax = getSelectedDataForPax(store);
  const propertyName = getSelectedHotelName(store);
  // const sumOfSelectedRates = getSumOfSelectedRates(store);
  return {
    isRtl,
    addons,
    titles,
    paxList,
    propertyName,
    propertyType,
    promoCode,
    isPromoCodeValid,
    isMobileView: isMobileView,
    selectedDataForPax,
    globalCurrency,
    globalCurrencyCode,
    selectedCurrency,
    selectedPaxId,
    cartTotalPrice: cartTotalPrices.totalPrice,
    simpleClubCartTotalPrice: cartTotalPrices.clubTotalPrice,

    cartTotalPrices,
    cartClubTotalPrices,

    clubUserLoggedIn,
    discountClubConfig,
    // sumOfSelectedRates,
    checkinDate,
    checkoutDate,
    isShowCancellationPolicy: ShowCancellationPolicy,
    showCartSubmitBtn,
    isDealMode,
    bookingRatesEnabled: bookingRatesEnabled,
    bookingRates: bookingRates[0] && bookingRates[0].scores,
    placeHolders,
    displayPriceWithoutTaxes,
    taxesPrecentage
  };
};

const mapDispatchToProps = dispatch => {
  const combinedActions = {
    ...addonsActions,
    ...generalActions
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartContainer);



// WEBPACK FOOTER //
// ./src/containers/CartContainer/CartContainer.js